import InventoryManagement from "../../components/dashboard/inventory/InventoryManagement";

export default function Inventory() {
  
  return (
    <main id="page-content" className="flex max-w-full flex-auto flex-col">
      <InventoryManagement />
    </main>
  )
}